import { useEffect, useState } from 'react';
import { getBusinessEmployees } from '../services/api_collection';
import { getFullName } from '../utils/common_functions';

const useGetBusinessEmp = () => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const response = await getBusinessEmployees();
        if (response?.statusCode === 200) {
          const data = response?.data;
          const formattedOptions = (data ?? []).map((emp) => ({
            label: getFullName(emp?.first_name, emp?.middle_name, emp?.last_name),
            value: emp.id
          }));

          setOptions(formattedOptions);
        } else {
          setError(response.message || 'Failed to fetch designations');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch designations');
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { options, loading, error };
};

export default useGetBusinessEmp;
